/// <reference path="../../../../../rcwebmodels/reeferstatus.cs.d.ts" />
/// <reference path="../../../../../rcwebmodels/preferencesettings.cs.d.ts" />
/* eslint-disable */
import * as React from 'react';
import { RCUtils } from './../../RCUtils';
import { PopupWindow } from './PopupWindow';
import $ from 'jquery';
import CheckboxTree from 'react-checkbox-tree';
import 'react-checkbox-tree/lib/react-checkbox-tree.css';
import * as RCNGWindow from '../sharedcomponents/ConfirmationWindow'; 
import lodashfilter from 'lodash/filter';
import uniq from 'lodash/uniq';
import * as Autosuggest from 'react-autosuggest';
var Config: any = require('../../Config.json');

var methodResult = true;
var selReefers;
var lastCheckedNodes = [];
var lastCheckedParentNode = "";
var selectedReefers = "";
var selectedUnits = "";
var IsTriggered = false;
var self;

export interface BookingSystemState {
    SelectedReefers: any[];
    BookingSystem: server.BookingSystem_UIModel;
    RefTemperatureUnit: server.RefTemperatureUnit[];
    isLoading: boolean;
    collapsed: boolean;
    checked: any;
    expanded: any;
    CustomerGroups: Customers[];   
    CustomerGroupsList: Customers[];   
    IsCustomerAccessHide: boolean;
    UnassignOption: string;
    lbl3rdPartyDisabled: boolean;
    lblBookingDisabled: boolean;
    lblBothDisabled: boolean;
    IsCommandIssued: boolean;
    PrevSelectedItems: any[];
    //RCNG-33-Start
    RefVessels: server.vesselsList[];
    suggestionsVesselId: any[],
    suggestionsVoyage: any[],
    suggestionsCalls: any[],
    ArrsuggestionsVesselId: any[],
    ArrsuggestionsVoyage: any[],
    ArrsuggestionsCalls: any[],
    //RCNG-33-End
}

var newBookingSystem: server.BookingSystem_UIModel = {
    BookedTemperature: '', BookedTemperatureUnit: '', BookingNumber: '', CustomerId: 0, eventmasteridForAssign: 0,
    eventmasteridforupdate: 0, RcdmasterId: 0, reeferID: '', Unitmasterid: 0, UserId: 0,
    RCDReportingInterval: '', SetPoint: '', EventDtm: '', SelectedUnits: [], Groups: [], IsEdit: false, UnassignMode: '', IsBookingModified: false, IsCustomerAccessModified: false,
    IsVVCModified: false,
    SelectedVesselCD: '',
    SelectedCall: '',
    SelectedVoyage: '',
    ArrSelectedVesselCD: '',
    ArrSelectedCall: '',
    ArrSelectedVoyage: '', userInput: 0,
    OperationalLevel: 'SelectedReefer', BookingInfo: [] //WI-27079:RCWeb - RC UI Edit Booking Changes
};

export class AssignBookingSystem extends React.Component<any, BookingSystemState> {
    constructor(props: any) {
        super(props);
        this.state = {
            SelectedReefers: [], BookingSystem: newBookingSystem, RefTemperatureUnit: [], isLoading: true, collapsed: false, CustomerGroups: [], checked: [], expanded: [], CustomerGroupsList: [], IsCustomerAccessHide: true, UnassignOption: '', lbl3rdPartyDisabled: false, lblBookingDisabled: false, lblBothDisabled: false, IsCommandIssued: false, PrevSelectedItems: []
            , RefVessels: [], suggestionsVesselId: [], suggestionsVoyage: [], suggestionsCalls: [], ArrsuggestionsVesselId: [], ArrsuggestionsVoyage: [], ArrsuggestionsCalls: []       };
        this.onCheck = this.onCheck.bind(this);
        this.onExpand = this.onExpand.bind(this);
        lastCheckedNodes = [];
        selReefers = this.props.reeferData;
        //this.getRefTemperatureUnit(); //Commented for RCNG-945
        IsTriggered = false;
        
        self = this;
    }
    //RCNG-33
    /* //Commented for RCNG-945
    getVVCInfo() {
        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/common/Getvessels')
        RCUtils.fetchRetry(request)
            .then(RCUtils.handleResponse)
            .then(response => response.json() as Promise<any>)
            .then(data => {
                if (data.length > 0) {
                    this.setState({ RefVessels: data });
                }
            });
    }

    getRefTemperatureUnit() {
        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/reeferstatus/GetRefTemperatureUnit')
        RCUtils.fetchFaultRetry(request)
            .then(RCUtils.handleResponse)
            .then(response => response.json() as Promise<server.RefTemperatureUnit[]>)
            .then(data => {
                this.setState({ RefTemperatureUnit: data });
            });
    }

    */

    UNSAFE_componentWillReceiveProps() {
        if (this.props.formname == "ReeferStatusGrid" && this.props.IsTriggered == "false") {
            IsTriggered = false;
        }
    }

    componentDidMount() {
        var reeferData = this.props.reeferData;
        //var EventMasterList = this.props.reeferFormatter.EventMasterList;
        if (reeferData != undefined && reeferData != null && reeferData.length > 0) {
            /* //Commented for RCNG-945
             var eventDescription = lodashfilter(EventMasterList, function (item) {
                return item.EventMasterID === reeferData[0].EventMasterID;
            });
            if (eventDescription.length > 0 && eventDescription != null) {
                var EventCd = eventDescription[0].EventCd;
            }*/
            this.setState({ SelectedReefers: reeferData }, () => {
                this.bindCustomerData(this.props.CustomerAccessData);
                //this.getVVCInfo();//RCNG-130 //Commented for RCNG-945
            });
            /* //Commented for RCNG-945
             var bookingSystem: server.BookingSystem_UIModel = JSON.parse(JSON.stringify(newBookingSystem));
            bookingSystem.reeferID = reeferData[0].ReeferID;
            if (reeferData[0].BookingNumber != null && reeferData[0].BookingNumber != "" && !this.ValidateBookingID(reeferData) && EventCd != "BDR")
                bookingSystem.IsEdit = true;
            else
                bookingSystem.IsEdit = false;
            if (bookingSystem.IsEdit) {               
                if (reeferData[0].TemperatureUnit != null) {
                    var _lststrValue = reeferData[0].TemperatureUnit.toString().trim().split('@');
                    var temperatureCd = _lststrValue[1];
                }
                bookingSystem.BookedTemperatureUnit = temperatureCd != undefined ? temperatureCd : "C";
                bookingSystem.BookingNumber = reeferData[0].BookingNumber;
                bookingSystem.BookedTemperature = reeferData[0].BookedTemperature != null ? reeferData[0].BookedTemperature : '';
            }

            if (reeferData[0].LifecycleCd == 'L' || reeferData[0].LifecycleCd == 'R' || reeferData[0].LifecycleCd == 'D' || reeferData[0].LifecycleCd == 'P') {
                var departingVVC = reeferData[0].DepartingVVC.split('-');
                var depVoyage = departingVVC[0].trim().length > 0 ? departingVVC[0].trim() : '';
                var depCall = departingVVC[1].trim().length > 0 ? departingVVC[1].trim() : '';
                var arrivingVVC = reeferData[0].ArrivingVVC.split('-');
                var arrVoyage = arrivingVVC[0].trim().length > 0 ? arrivingVVC[0].trim() : '';
                var arrCall = arrivingVVC[1].trim().length > 0 ? arrivingVVC[1].trim() : '';

                bookingSystem.SelectedVoyage = depVoyage;
                bookingSystem.SelectedCall = depCall;
                bookingSystem.SelectedVesselCD = depVoyage != '' ? reeferData[0].VesselCd : '';
                bookingSystem.ArrSelectedVesselCD = arrVoyage != '' ? reeferData[0].VesselCd : '';
                bookingSystem.ArrSelectedVoyage = arrVoyage;
                bookingSystem.ArrSelectedCall = arrCall;
            } 

            this.setState({ BookingSystem: bookingSystem });*/
        }
    }

    bindCustomerData(customerAccessData: any) {
        if (customerAccessData != undefined) {
            this.setState({ CustomerGroups: JSON.parse(JSON.stringify(customerAccessData)), CustomerGroupsList: customerAccessData });
            if (customerAccessData.length > 0) {
                var defaultChecked = [];
                var defaultExpand = [];
                $.each(customerAccessData, function (index, value) {
                    if (value.isSelected == true) {
                        defaultExpand.push(value.value);
                    }
                    $.each(value.children, function (ind, val) {
                        if (val.isSelected == true) {
                            defaultChecked.push(val.value);
                        }
                    });
                });
                this.setState({ isLoading: false, IsCustomerAccessHide: false, checked: defaultChecked, expanded: defaultExpand }, () => { this.onCheck(this.state.checked); });
            }
            else {
                lastCheckedNodes = [];
                this.setState({ isLoading: false, checked: [], expanded: [], CustomerGroups: [], CustomerGroupsList: [], IsCustomerAccessHide: true });
            }
        }
    }

    onCheck(checked) {        
        if (checked.length > 0) {
            var customersList = this.state.CustomerGroupsList;
            if (lastCheckedNodes.length == 0) {
                lastCheckedParentNode = checked[0].toString().split('_')[0];
                lastCheckedNodes = checked;
                for (var i = 0; i < customersList.length; i++) {
                    for (var j = 0; j < customersList[i].children.length; j++) {
                        if (lastCheckedParentNode != customersList[i].children[j].value.split('_')[0]) {
                            customersList[i].children[j].disabled = true;
                        }
                    }
                }
                this.setState({ CustomerGroups: JSON.parse(JSON.stringify(customersList)), checked: checked });
            }
            else {
                $.each(checked, function (index, value) {
                    if (lastCheckedParentNode != value.split('_')[0]) {
                        lastCheckedParentNode = value.split('_')[0];
                        return false;
                    }
                });
                for (var i = 0; i < customersList.length; i++) {
                    for (var j = 0; j < customersList[i].children.length; j++) {
                        if (lastCheckedParentNode != customersList[i].children[j].value.split('_')[0]) {
                            customersList[i].children[j].disabled = true;
                            var chk = checked.indexOf(customersList[i].children[j].value);
                            if (chk >= 0)
                                checked.splice(chk, 1);
                            if (checked.length == 0)
                                customersList[i].children[j].disabled = false;
                        }
                        else {
                            customersList[i].children[j].disabled = false;
                        }
                    }
                }
                lastCheckedNodes = checked;
                this.setState({ CustomerGroups: JSON.parse(JSON.stringify(customersList)), checked: checked });
            }
        }
    }

    onExpand(expanded) {
        this.setState({ expanded: expanded });
    }

    submitAssignBookingConfirm() {
        
       // if (this.state.BookingSystem.BookingNumber == null || this.state.BookingSystem.BookingNumber == '') { //Commented for RCNG-945
            if (this.state.checked.length == 0)
                PopupWindow.showErrorMessage("Alert", "Please provide Customer Access details.");
            else {
                //var confirmationMessage = "Booking data will not be saved because a booking number has not been provided. Continue?"; //Commented for RCNG-945
                //RCNGWindow.ConfirmWindow.showConfirmBox(confirmationMessage, this.submitBookingAction.bind(this), this.closeConfirmation.bind(this));
                this.submitBookingAction();
            }
        //}
        //else {          
        //    this.submitAssignBooking();
        //}
    }

    closeConfirmation() {
        RCNGWindow.ConfirmWindow.close();
    }

    submitBookingAction() {
        //if (IsTriggered == false) {
        //    IsTriggered = true;            
            this.submitAssignBooking();
        //}
        RCNGWindow.ConfirmWindow.close();
    }    

    submitAssignBooking() {
        /* RCNG 94 start */
        //RCNG-33 Start
        
        ////Commented  from here for RCNG-945
        //const { SelectedVesselCD, SelectedVoyage, SelectedCall, ArrSelectedVesselCD, ArrSelectedVoyage, ArrSelectedCall } = this.state.BookingSystem;
        //const { DepartingVVC, ArrivingVVC, VesselCd, LifecycleCd } = this.state.SelectedReefers[0];
        //var PrevDepartingVoyage = DepartingVVC.split('-')[0].trim();
        //var PrevDepartingCall = DepartingVVC.split('-')[1].trim();
        //var PrevArrivalVoyage = ArrivingVVC.split('-')[0].trim();
        //var PrevArrivalCall = ArrivingVVC.split('-')[1].trim();

        //var currentdepartingVVC = VesselCd + ',' + PrevDepartingVoyage + ',' + PrevDepartingCall;
        //var currentarrivalVVC = (PrevArrivalVoyage != '' ? VesselCd : '') + ',' + PrevArrivalVoyage + ',' + PrevArrivalCall;
        //var chosenDepartingVVC = SelectedVesselCD + ',' + SelectedVoyage + ',' + SelectedCall;
        //var chosenArrivalVVC = ArrSelectedVesselCD + ',' + ArrSelectedVoyage + ',' + ArrSelectedCall;
        //
        ////if ((LifecycleCd == 'C' || LifecycleCd == null) && chosenDepartingVVC == ',,')
        //if (LifecycleCd == 'C' || LifecycleCd == null)
        //    currentdepartingVVC = ',,';
        ////if ((LifecycleCd == 'C' || LifecycleCd == null) && chosenArrivalVVC == ',,')
        //if (LifecycleCd == 'C' || LifecycleCd == null)
        //    currentarrivalVVC = ',,';

        //if (currentdepartingVVC != chosenDepartingVVC || currentarrivalVVC != chosenArrivalVVC)
        //    this.state.BookingSystem.IsVVCModified = true;
        //else
        //    this.state.BookingSystem.IsVVCModified = false;//RCNG-139
        ////RCNG-33 End
        // /* RCNG 94 end */
        ////if (this.state.BookingSystem.IsEdit) {
        //    if (this.state.SelectedReefers[0].TemperatureUnit != null) {
        //        var _lststrValue = this.state.SelectedReefers[0].TemperatureUnit.toString().trim().split('@');
        //        var temperatureCd = _lststrValue[1];
        //        if (this.state.BookingSystem.BookedTemperatureUnit != temperatureCd) {
        //            if (this.state.BookingSystem.BookedTemperatureUnit == "" && temperatureCd == "C") { }
        //            else
        //                this.state.BookingSystem.IsBookingModified = true;
        //        }
        //    }
        //    else if(this.state.BookingSystem.BookedTemperatureUnit!= null)
        //        this.state.BookingSystem.IsBookingModified = true;

        //    if (this.state.SelectedReefers[0].BookedTemperature != null) {
        //        if (this.state.BookingSystem.BookedTemperature != this.state.SelectedReefers[0].BookedTemperature) {
        //            this.state.BookingSystem.IsBookingModified = true;
        //        }
        //    }
        //    else if (this.state.BookingSystem.BookedTemperature != null && this.state.BookingSystem.BookedTemperature != '')
        //        this.state.BookingSystem.IsBookingModified = true;
        //Commented till here RCNG-945
            var checkedGroups = [];
            var existingGroups = [];
            if (this.state.checked.length > 0) {
                $.each(this.state.checked, function (index, value) {
                    checkedGroups.push(value);
                });
            }
            if (this.state.CustomerGroupsList.length > 0) {
                $.each(this.state.CustomerGroupsList, function (index, value) {
                    $.each(value.children, function (ind, val) {
                        if (val.isSelected == true) {
                            existingGroups.push(val.value);
                        }
                    });
                });
            }
            var IsAccessModified = false;
            if (checkedGroups.length == existingGroups.length) {
                if (checkedGroups.length > 0 && existingGroups.length > 0) {
                    $.each(checkedGroups, function (key, value) {
                        var index = $.inArray(value, existingGroups);
                        if (index == -1) {
                            IsAccessModified = true
                        }
                    });
                }
            }
            else
                IsAccessModified = true;

            this.state.BookingSystem.IsCustomerAccessModified = IsAccessModified;
            /* RCNG 94 start */
            //RCNG-33
            //if (!this.state.BookingSystem.IsBookingModified && !this.state.BookingSystem.IsCustomerAccessModified && !this.state.BookingSystem.IsVVCModified) { //Commented for RCNG-945
            if (!this.state.BookingSystem.IsCustomerAccessModified) {
                PopupWindow.showErrorMessage("Alert", "Please modify Customer Access details.");
                return;
            }
        //}
        //RCNG 94 //RCNG-33  
        this.submitAssignBookingAfterPrompt();//Added for RCNG-945
        //this.ValidateVVCandSubmitBooking(); //Commented for RCNG-945
        
        //Moved below code to new method - submitbookingafterprompt()
        //this.state.BookingSystem.RcdmasterId = this.state.SelectedReefers[0].RCDMasterID;
        //this.state.BookingSystem.Unitmasterid = this.state.SelectedReefers[0].UnitMasterID;
        //this.state.BookingSystem.CustomerId = this.state.SelectedReefers[0].CustomerID;
        //this.state.BookingSystem.UserId = this.props.UserID;
        //this.state.BookingSystem.eventmasteridForAssign = 0;
        //this.state.BookingSystem.eventmasteridforupdate = 0;
        //this.state.BookingSystem.EventDtm = this.state.SelectedReefers[0].EventDTTM;
        //this.state.BookingSystem.RCDReportingInterval = this.state.SelectedReefers[0].RCDReportingInterval;
        //this.state.BookingSystem.SetPoint = this.state.SelectedReefers[0].SetPoint;

        //var checkedGroupIds = [];
        //var selUnits = [];
        //var checkedList = this.state.checked;

        //if (this.state.SelectedReefers.length > 1) {
        //    $.each(this.state.SelectedReefers, function (index, value) {
        //        selectedUnits = selectedUnits == "" ? value.UnitMasterID : selectedUnits + "," + value.UnitMasterID;
        //    });
        //}
        //else {
        //    selectedUnits = this.state.SelectedReefers[0].UnitMasterID.toString();
        //}

        //$.each(selectedUnits.split(','), function (index, value) {
        //    selUnits.push(parseInt(value));
        //});

        //$.each(checkedList, function (index, value) {            
        //    checkedGroupIds.push(parseInt(value.split(':')[1].split('_')[0]));
        //});

        //this.state.BookingSystem.SelectedUnits = selUnits;
        //this.state.BookingSystem.Groups = checkedGroupIds;
        //$('#globalLoader').show();
        //var bookingSystem = JSON.stringify(this.state.BookingSystem);
        //var url = Config.ApiBaseUrl + '/api/reeferstatus/AssignBookingdetails';
        //var request = RCUtils.FetchRequest(url, { method: 'POST', body: bookingSystem, headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
        //fetch(request)
        //    .then(RCUtils.handleError)
        //    .then(response => response.json())
        //    .then(data => {
        //        $('#globalLoader').hide();
        //        if (data == 'Booking assigned successfully.' || data == 'Booking updated successfully.') {
        //            $("#contextMenuModel .close").click();
        //            if (data == 'Booking assigned successfully.' && this.state.BookingSystem.Groups.length > 0 && this.state.BookingSystem.BookingNumber != null && this.state.BookingSystem.BookingNumber != '')
        //                data = "Booking and Customer Access assigned successfully.";
        //            if (data == 'Booking assigned successfully.' && this.state.BookingSystem.Groups.length > 0 && (this.state.BookingSystem.BookingNumber == null || this.state.BookingSystem.BookingNumber == ''))
        //                data = "Customer Access assigned successfully.";
        //            if (data == 'Booking updated successfully.' && this.state.BookingSystem.Groups.length > 0 && this.state.BookingSystem.IsCustomerAccessModified && this.state.BookingSystem.IsBookingModified)
        //                data = "Booking and Customer Access updated successfully.";
        //            if (data == 'Booking updated successfully.' && this.state.BookingSystem.Groups.length > 0 && this.state.BookingSystem.IsCustomerAccessModified && !this.state.BookingSystem.IsBookingModified)
        //                data = "Customer Access updated successfully.";                  
        //            this.setState({ IsCommandIssued: true, PrevSelectedItems: this.props.reeferData }, () => { this.props.IsCommandIssued(this.state.IsCommandIssued); this.props.PrevSelectedItems(this.props.reeferData) });
        //            this.props.refreshStatusGrid();
        //            PopupWindow.showErrorMessage("Booking and Access", data);
                    
        //        }
        //        else {
        //            PopupWindow.showErrorMessage("Booking and Access", data);
        //        }
        //    });
    }

    submitAssignBookingAfterPrompt() {
        
        $('#globalLoader').show(); //Added for RCNG-945
        this.state.BookingSystem.RcdmasterId = this.state.SelectedReefers[0].RCDMasterID;
        this.state.BookingSystem.Unitmasterid = this.state.SelectedReefers[0].UnitMasterID;
        this.state.BookingSystem.CustomerId = this.state.SelectedReefers[0].CustomerID;
        this.state.BookingSystem.UserId = this.props.UserID;
        this.state.BookingSystem.eventmasteridForAssign = 0;
        this.state.BookingSystem.eventmasteridforupdate = 0;
        this.state.BookingSystem.EventDtm = this.state.SelectedReefers[0].EventDTTM;
        this.state.BookingSystem.RCDReportingInterval = this.state.SelectedReefers[0].RCDReportingInterval;
        this.state.BookingSystem.SetPoint = this.state.SelectedReefers[0].SetPoint;

        var checkedGroupIds = [];
        var selUnits = [];
        var checkedList = this.state.checked;

        if (this.state.SelectedReefers.length > 1) {
            $.each(this.state.SelectedReefers, function (index, value) {
                selectedUnits = selectedUnits == "" ? value.UnitMasterID : selectedUnits + "," + value.UnitMasterID;
            });
        }
        else {
            selectedUnits = this.state.SelectedReefers[0].UnitMasterID.toString();
        }

        $.each(selectedUnits.split(','), function (index, value) {
            selUnits.push(parseInt(value));
        });

        $.each(checkedList, function (index, value) {
            checkedGroupIds.push(parseInt(value.split(':')[1].split('_')[0]));
        });

        this.state.BookingSystem.SelectedUnits = selUnits;
        this.state.BookingSystem.Groups = checkedGroupIds;
        //$('#globalLoader').show();
        var bookingSystem = JSON.stringify(this.state.BookingSystem);
        var url = Config.ApiBaseUrl + '/api/reeferstatus/AssignBookingdetails';
        var request = RCUtils.FetchRequest(url, { method: 'POST', body: bookingSystem, headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json())
            .then(data => {
                $('#globalLoader').hide();
                if (data == 'Booking assigned successfully.' || data == 'Booking updated successfully.') {
                    $("#contextMenuModel .btn-close").click();
                    //RCNG-135 Start
                    /*
                    if (data == 'Booking assigned successfully.' && this.state.BookingSystem.Groups.length > 0 && this.state.BookingSystem.BookingNumber != null && this.state.BookingSystem.BookingNumber != '')
                        data = "Booking and Customer Access assigned successfully.";
                    if (data == 'Booking assigned successfully.' && this.state.BookingSystem.Groups.length > 0 && (this.state.BookingSystem.BookingNumber == null || this.state.BookingSystem.BookingNumber == ''))
                        data = "Customer Access assigned successfully.";
                    if (data == 'Booking updated successfully.' && this.state.BookingSystem.Groups.length > 0 && this.state.BookingSystem.IsCustomerAccessModified && this.state.BookingSystem.IsBookingModified)
                        data = "Booking and Customer Access updated successfully.";
                    if (data == 'Booking updated successfully.' && this.state.BookingSystem.Groups.length > 0 && this.state.BookingSystem.IsCustomerAccessModified && !this.state.BookingSystem.IsBookingModified)
                        data = "Customer Access updated successfully.";
                    */
                    var infoMessage = "";
                    if (self.props.reeferData[0].CustomerName === JSON.parse(sessionStorage.getItem('customerDetails')).CustomerName) //Added for RCNG-945
                        infoMessage = "Customer Access assigned successfully.";
                    else
                        infoMessage = "Customer Access updated successfully.";
                    /* //Commented for RCNG-945
                    if (data == 'Booking assigned successfully.') {
                        if (this.state.BookingSystem.Groups.length > 0 && this.state.BookingSystem.BookingNumber != null && this.state.BookingSystem.BookingNumber != '') {
                            if (this.state.BookingSystem.IsVVCModified)
                                infoMessage = "Booking, Customer Access and VVC Changes assigned successfully.";
                            else
                                infoMessage = "Booking and Customer Access assigned successfully.";
                        }

                        if (this.state.BookingSystem.Groups.length > 0 && (this.state.BookingSystem.BookingNumber == null || this.state.BookingSystem.BookingNumber == '')) {
                            if (this.state.BookingSystem.IsVVCModified)
                                infoMessage = "Customer Access and VVC Changes assigned successfully.";
                            else
                                infoMessage = "Customer Access assigned successfully.";
                        }
                        if (this.state.BookingSystem.Groups.length <= 0 && this.state.BookingSystem.BookingNumber != null && this.state.BookingSystem.BookingNumber != '') {
                            if (this.state.BookingSystem.IsVVCModified)
                                infoMessage = "Booking and VVC Changes assigned successfully.";
                            else
                                infoMessage = "Booking assigned successfully.";
                        }

                    }
                    if (data == 'Booking updated successfully.') {
                        if (this.state.BookingSystem.IsCustomerAccessModified && this.state.BookingSystem.IsBookingModified) {
                            if (this.state.BookingSystem.IsVVCModified)
                                infoMessage = "Booking, Customer Access and VVC Changes updated successfully.";
                            else
                                infoMessage = "Booking and Customer Access updated successfully.";
                        }

                        if (this.state.BookingSystem.IsCustomerAccessModified && !this.state.BookingSystem.IsBookingModified) {
                            if (this.state.BookingSystem.IsVVCModified)
                                infoMessage = "Customer Access and VVC Changes updated successfully.";
                            else
                                infoMessage = "Customer Access updated successfully.";
                        }
                        if (!this.state.BookingSystem.IsCustomerAccessModified && this.state.BookingSystem.IsBookingModified) {
                            if (this.state.BookingSystem.IsVVCModified)
                                infoMessage = "Booking and VVC Changes updated successfully.";
                            else
                                infoMessage = "Booking updated successfully.";
                        }
                    }
                    */
                    //RCNG-135 End
                    this.setState({ IsCommandIssued: true, PrevSelectedItems: this.props.reeferData }, () => { this.props.IsCommandIssued(this.state.IsCommandIssued); this.props.PrevSelectedItems(this.props.reeferData) });
                    this.props.refreshStatusGrid();

                    //RCNG-135
                    if (infoMessage != '')
                        PopupWindow.showErrorMessage("Third-Party Access", infoMessage);

                }
                else {
                    PopupWindow.showErrorMessage("Third-Party Access", data);
                }
            });
    }

    componentWillReceiveProps(nextprops: any) {  
        var reeferData = nextprops.reeferData;
        
        //var EventMasterList = nextprops.reeferFormatter.EventMasterList; //Commented for RCNG-945
        if (reeferData != undefined && reeferData != null && reeferData.length > 0) { 
            /* //Commented for RCNG-945
             var eventDescription = lodashfilter(EventMasterList, function (item) {
                return item.EventMasterID === reeferData[0].EventMasterID;
            });
            if (eventDescription.length > 0 && eventDescription != null) {
                var EventCd = eventDescription[0].EventCd;
            }
            this.getRefTemperatureUnit();*/
            this.setState({ SelectedReefers: reeferData }, () => {
                this.bindCustomerData(nextprops.CustomerAccessData);
                //this.getVVCInfo();//RCNG-130 //Commented for RCNG-945
            });
            /* //Commented for RCNG-945
             var bookingSystem: server.BookingSystem_UIModel = JSON.parse(JSON.stringify(newBookingSystem));
            bookingSystem.reeferID = reeferData[0].ReeferID;
            if (reeferData[0].BookingNumber != null && reeferData[0].BookingNumber != "" && !this.ValidateBookingID(reeferData) && EventCd != "BDR")
                bookingSystem.IsEdit = true;
            else
                bookingSystem.IsEdit = false;
            if (bookingSystem.IsEdit) {
                if (reeferData[0].TemperatureUnit != null) {
                    var _lststrValue = reeferData[0].TemperatureUnit.toString().trim().split('@');
                    var temperatureCd = _lststrValue[1];
                }
                bookingSystem.BookedTemperatureUnit = temperatureCd != undefined ? temperatureCd : "C";
                bookingSystem.BookingNumber = reeferData[0].BookingNumber;
                bookingSystem.BookedTemperature = reeferData[0].BookedTemperature != null ? reeferData[0].BookedTemperature : '';
            }
            //RCNG-33
            if (reeferData[0].LifecycleCd == 'L' || reeferData[0].LifecycleCd == 'R' || reeferData[0].LifecycleCd == 'D' || reeferData[0].LifecycleCd == 'P') {
                var departingVVC = reeferData[0].DepartingVVC.split('-');
                
                var depVoyage = departingVVC[0].trim().length > 0 ? departingVVC[0].trim() : '';
                var depCall = departingVVC[1].trim().length > 0 ? departingVVC[1].trim() : '';
                var arrivingVVC = reeferData[0].ArrivingVVC.split('-');
                var arrVoyage = arrivingVVC[0].trim().length > 0 ? arrivingVVC[0].trim() : '';
                var arrCall = arrivingVVC[1].trim().length > 0 ? arrivingVVC[1].trim() : '';

                bookingSystem.SelectedVoyage = depVoyage;
                bookingSystem.SelectedCall = depCall;
                bookingSystem.SelectedVesselCD = depVoyage != '' ? reeferData[0].VesselCd : '';
                bookingSystem.ArrSelectedVesselCD = arrVoyage != '' ? reeferData[0].VesselCd : '';
                bookingSystem.ArrSelectedVoyage = arrVoyage;
                bookingSystem.ArrSelectedCall = arrCall;
            }
            
            this.setState({ BookingSystem: bookingSystem });*/
        }       
    }

    Temperaturechange(event: React.FormEvent<HTMLSelectElement>) {
        var Value: string = event.currentTarget.value;
        var bookingSystem: server.BookingSystem_UIModel = JSON.parse(JSON.stringify(this.state.BookingSystem));
        bookingSystem.BookedTemperatureUnit = Value;
        this.setState({ BookingSystem: bookingSystem });
    }

    BookingNumberChange(event: React.FormEvent<HTMLInputElement>) {
        var Value: string = event.currentTarget.value;
        var bookingSystem: server.BookingSystem_UIModel = JSON.parse(JSON.stringify(this.state.BookingSystem));
        bookingSystem.BookingNumber = Value;
        this.setState({ BookingSystem: bookingSystem });       
    }

    BookingTemperatureChange(event: React.FormEvent<HTMLInputElement>) {
        var Value: string = event.currentTarget.value.trim();
        var bookingSystem: server.BookingSystem_UIModel = JSON.parse(JSON.stringify(this.state.BookingSystem));
        const IsMatch = /^[-+]?[0-9]*\.?[0-9]*([eE][-+]?[0-9]+)?$/;
        if (IsMatch.test(Value)) {
            bookingSystem.BookedTemperature = Value;
            this.setState({ BookingSystem: bookingSystem });
        }

        else
            return;
    }
 //WI-27079:RCWeb - RC UI Edit Booking Changes start
    setBookinglevel() {
        RCNGWindow.ConfirmWindow.close();
        var bookingSystem: server.BookingSystem_UIModel = JSON.parse(JSON.stringify(this.state.BookingSystem));
        bookingSystem.OperationalLevel = 'AllReefers';
        //this.setState({ BookingSystem: bookingSystem });
        //this.submitBooking();
        this.setState({ BookingSystem: bookingSystem }, () => {
            $('#globalLoader').show();
            this.submitAssignBookingAfterPrompt();
        });
    }
    setReeferlevel() {
        RCNGWindow.ConfirmWindow.close();
        var bookingSystem: server.BookingSystem_UIModel = JSON.parse(JSON.stringify(this.state.BookingSystem));
        bookingSystem.OperationalLevel = 'SelectedReefer';
        //this.setState({ BookingSystem: bookingSystem });
        //this.submitBooking();
        this.setState({ BookingSystem: bookingSystem }, () => {
            $('#globalLoader').show();
            this.submitAssignBookingAfterPrompt();
        });
    }

    submitAssignBookingAfterPromptMessage() {
        if (this.state.BookingSystem.BookingNumber != null && this.state.BookingSystem.BookingNumber != "") {
            $('#globalLoader').show();
            var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/reeferstatus/GetbookingReefers?BookingNumber=' + this.state.BookingSystem.BookingNumber)
            fetch(request)
                .then(RCUtils.handleError)
                .then(response => response.json() as Promise<string[]>)
                .then(data => {
                    var bookingSystem: server.BookingSystem_UIModel = JSON.parse(JSON.stringify(this.state.BookingSystem));
                    bookingSystem.BookingInfo = data;
                    this.setState({ BookingSystem: bookingSystem });
                    if (!(this.state.BookingSystem.IsEdit) && data.length >= 1) {
                        $('#globalLoader').hide();
                        var confirmationMessage = "";
                        if (this.state.BookingSystem.IsVVCModified)
                            confirmationMessage = "More than one reefer is associated with this booking.  Do you wish to apply the updated “Booking and VVC Changes” to all associated reefers or selected reefer?";
                        else
                            confirmationMessage = "More than one reefer is associated with this booking.  Do you wish to apply the updated “Booked Temperature” to all associated reefers or selected reefer?";
                        RCNGWindow.ConfirmWindow.showConfirmBoxwith3options(confirmationMessage, this.setBookinglevel.bind(this), this.setReeferlevel.bind(this), this.closeConfirmation.bind(this));
                    }
                    else if (this.state.BookingSystem.IsEdit && this.state.BookingSystem.IsBookingModified && data.length > 1) {
                        $('#globalLoader').hide();
                        var confirmationMessage = "";
                        if (this.state.BookingSystem.IsVVCModified)
                            confirmationMessage = "More than one reefer is associated with this booking.  Do you wish to apply the updated “Booking and VVC Changes” to all associated reefers or selected reefer?";
                        else
                            confirmationMessage = "More than one reefer is associated with this booking.  Do you wish to apply the updated “Booked Temperature” to all associated reefers or selected reefer?";
                        RCNGWindow.ConfirmWindow.showConfirmBoxwith3options(confirmationMessage, this.setBookinglevel.bind(this), this.setReeferlevel.bind(this), this.closeConfirmation.bind(this));
                    }
                    else {
                        this.submitAssignBookingAfterPrompt();
                    }

                });
        }
        else {
            $('#globalLoader').show();
            this.submitAssignBookingAfterPrompt();
        }
    }

    CloseModal() {
        lastCheckedNodes = [];
        this.setState({ checked: lastCheckedNodes });
    }  

    ValidateBookingID(reeferData: any) {
        if (reeferData.length > 0 && reeferData[0].LastBookingEventMasterId != null && reeferData[0].LastBookingEventMasterId.length > 0) {
            for (var lastBookingID in reeferData[0].LastBookingEventMasterId) {
                if (reeferData[0].EventMasterID == parseInt(reeferData[0].LastBookingEventMasterId[lastBookingID])) {
                    return true;
                }
            }
        }
        return false;
    }

    //RCNG-33 Start
    ValidateVVCandSubmitBooking() {
        
        const { SelectedVesselCD, SelectedVoyage, SelectedCall, ArrSelectedVesselCD, ArrSelectedVoyage, ArrSelectedCall } = this.state.BookingSystem;
        var vesselHasVoyageCalls;
        
        if (SelectedVesselCD != '' && SelectedVesselCD != null) {
            var selectedVessel = this.state.RefVessels.filter(x => x.VesselCd.toUpperCase() == SelectedVesselCD.toUpperCase());
            if (selectedVessel != null && selectedVessel != undefined && selectedVessel.length > 0) {
                vesselHasVoyageCalls = selectedVessel[0].VoyagesHaveCalls;
            }

            if (SelectedVesselCD != null && SelectedVesselCD != '' && ArrSelectedVesselCD != null && ArrSelectedVesselCD != '') {
                if (SelectedVesselCD != ArrSelectedVesselCD) {
                    PopupWindow.showErrorMessage('Alert', 'Departing and Arriving VVC should be same');
                    return false;
                }
            }
        }

        if (((SelectedVesselCD == '' && SelectedVoyage == '' && SelectedCall == '') || (SelectedVesselCD != '' && SelectedVoyage != '' && (!vesselHasVoyageCalls || (vesselHasVoyageCalls && SelectedCall != '')))) &&
            ((ArrSelectedVesselCD == '' && ArrSelectedVoyage == '' && ArrSelectedCall == '') || (ArrSelectedVesselCD != '' && ArrSelectedVoyage != '' && (!vesselHasVoyageCalls || (vesselHasVoyageCalls && ArrSelectedCall != ''))))) {
            
            var DepVVC = SelectedVesselCD + ',' + SelectedVoyage + ',' + SelectedCall;
            var ArrVVC = ArrSelectedVesselCD + ',' + ArrSelectedVoyage + ',' + ArrSelectedCall;

            var url = Config.ApiBaseUrl + '/api/reeferstatus/ValidateVVCEntered?DepVVC=' + DepVVC + '&ArrVVC=' + ArrVVC;
            
            var request = RCUtils.FetchRequest(url, { method: 'GET', headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
            RCUtils.fetchRetry(request)
                .then(RCUtils.handleResponse)
                .then(response => response.json() as Promise<string>)
                .then(data => {
                    
                    if (data != '') {
                        if (data == 'DNE')
                            PopupWindow.showErrorMessage("Error", 'The Departing VVC, ' + SelectedVesselCD + ' ' + SelectedVoyage + ' ' + SelectedCall + ', does not exist. A VVC cannot be created here.');
                        else if (data == 'ANE')
                            PopupWindow.showErrorMessage("Error", 'The Arriving VVC, ' + ArrSelectedVesselCD + ' ' + ArrSelectedVoyage + ' ' + ArrSelectedCall + ', does not exist. A VVC cannot be created here.');
                        return false;
                    }
                    else {
                        
                        this.OnSubmitVVCValidations();
                    }
                });
        }
        else {
            
            if (SelectedVesselCD != null && SelectedVesselCD != '' && ArrSelectedVesselCD != null && ArrSelectedVesselCD != '') {
                if (SelectedVesselCD != ArrSelectedVesselCD) {
                    PopupWindow.showErrorMessage('Alert', 'Departing and Arriving VVC should be same');
                    return false;
                }
            }

            var voyagesHaveCalls;
            if (SelectedVesselCD != '' && SelectedVesselCD != null) {
                var selectedVessel = this.state.RefVessels.filter(x => x.VesselCd.toUpperCase() == SelectedVesselCD.toUpperCase());
                if (selectedVessel != null && selectedVessel != undefined && selectedVessel.length > 0) {
                    voyagesHaveCalls = selectedVessel[0].VoyagesHaveCalls;
                }
                else {
                    PopupWindow.showErrorMessage('Alert', 'Departing VVC not exists');
                    return false;
                }
            }


            if (SelectedVesselCD != '' && SelectedVoyage == '') {
                PopupWindow.showErrorMessage('Alert', 'A voyage number must be specified for the Departing VVC.');
                return false;
            }
            else if (SelectedVesselCD != '' && voyagesHaveCalls && SelectedCall == '') {
                PopupWindow.showErrorMessage('Alert', 'A call must be specified for the Departing VVC.');
                return false;
            }
            else if (ArrSelectedVesselCD != '' && ArrSelectedVoyage == '') {
                PopupWindow.showErrorMessage('Alert', 'A voyage number must be specified for the Arriving VVC.');
                return false;
            }
            else if (ArrSelectedVesselCD != '' && voyagesHaveCalls && ArrSelectedCall == '') {
                PopupWindow.showErrorMessage('Alert', 'A call must be specified for the Arriving VVC.');
                return false;
            }
        }
        
    }
    OnSubmitVVCValidations() {
        
        methodResult = false;
        const { SelectedVesselCD, SelectedVoyage, SelectedCall, ArrSelectedVesselCD, ArrSelectedVoyage, ArrSelectedCall } = this.state.BookingSystem;
        const { DepartingVVC, ArrivingVVC, VesselCd, LifecycleCd } = this.state.SelectedReefers[0];
        var PrevDepartingVoyage = DepartingVVC.split('-')[0].trim();
        var PrevDepartingCall = DepartingVVC.split('-')[1].trim();
        var PrevArrivalVoyage = ArrivingVVC.split('-')[0].trim();
        var PrevArrivalCall = ArrivingVVC.split('-')[1].trim();

        var currentdepartingVVC = (VesselCd == null ? '' : VesselCd) + ',' + PrevDepartingVoyage + ',' + PrevDepartingCall;
        var currentarrivalVVC = (PrevArrivalVoyage != ''? VesselCd:'') + ',' + PrevArrivalVoyage + ',' + PrevArrivalCall;
        var chosenDepartingVVC = SelectedVesselCD + ',' + SelectedVoyage + ',' + SelectedCall;
        var chosenArrivalVVC = ArrSelectedVesselCD + ',' + ArrSelectedVoyage + ',' + ArrSelectedCall;

        var submitVVCInputData: server.SubmitVVCInputData = {
            CurrentDepVVC: (LifecycleCd == 'C' || LifecycleCd == null) ? ',,' : currentdepartingVVC,// && chosenDepartingVVC == ',,'
            CurrentArrVVC: (LifecycleCd == 'C' || LifecycleCd == null) ? ',,' : currentarrivalVVC, // && chosenArrivalVVC == ',,'
            ChosenDepVVC: chosenDepartingVVC,
            ChosenArrVVC: chosenArrivalVVC,
            LifecycleCd: LifecycleCd
        }
        var inputBody = JSON.stringify(submitVVCInputData);
        var url = Config.ApiBaseUrl + '/api/reeferstatus/SubmitVVC';
        
        var request = RCUtils.FetchRequest(url, { method: 'POST', body: inputBody, headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
        RCUtils.fetchRetry(request)
            .then(RCUtils.handleResponse)
            .then(response => response.json() as Promise<server.SubmitVVCResult>)
            .then(data => {
                
                if (data.IsPromptMessage) {
                    $('#globalLoader').hide();
                    RCNGWindow.ConfirmWindow.showConfirmBox(data.ResultMessage, this.SaveUserInputToState.bind(this, data.PromptId), this.closeUserConfirmation.bind(this));
                }
                else if (!data.IsPromptMessage && data.ResultMessage != null && data.ResultMessage != '') {
                    PopupWindow.showErrorMessage('Error', data.ResultMessage);
                    methodResult = false;
                    return methodResult;
                }
                else {
                    this.SaveUserInputToState(data.PromptId);
                    return methodResult;
                }
            });
    }

    closeUserConfirmation() {
        methodResult = false;
        RCNGWindow.ConfirmWindow.close();
        return false;
    }
    //RCNG-33 Start
    SaveUserInputToState(userInput: number) {
        
        $('#globalLoader').show();
        var bookingSystem: server.BookingSystem_UIModel = JSON.parse(JSON.stringify(this.state.BookingSystem));
        bookingSystem.userInput = userInput;
               
        methodResult = true;
        this.setState({ BookingSystem: bookingSystem }, () => {
            RCNGWindow.ConfirmWindow.close();//RCNG-109
            this.submitAssignBookingAfterPromptMessage();
        }); //WI-27079:RCWeb - RC UI Edit Booking Changes
    }

    onSuggestionsFetchRequestedforvessel = ({ value }) => {
        this.setState({
            suggestionsVesselId: this.getvesselNameSuggestions(value)
        });
    };
    getvesselNameSuggestions(value) {
        //var vessels = this.state.RefVessels;
        var VesselData = this.state.RefVessels.map(fence => fence.VesselCd);
        var vessels = uniq(VesselData);
        var inputValue = value.trim().toLowerCase();
        var inputLength = inputValue.length;
        return inputLength === 0 ? [] : vessels.filter(tag =>
            tag.toLowerCase().slice(0, inputLength) === inputValue
        );
    };
    onSuggestionsClearRequestedforvessel = () => {
        this.setState({
            suggestionsVesselId: []
        });
    };
    onChangeVesselId = (event, { newValue }) => {
        var filters = this.state.BookingSystem;
        filters.SelectedVesselCD = newValue;
        filters.SelectedVoyage = '';
        filters.SelectedCall = '';
        //$('#vesselID').addClass("fw-semibold");

        this.setState({
            BookingSystem: filters
        });
        this.setState({
            suggestionsVoyage: this.getvoyageNameSuggestions(newValue)
        });
    };
    onChangcall = (event, { newValue }) => {
        var filters = this.state.BookingSystem;
        filters.SelectedCall = newValue;
        //$('#vesselID').addClass("fw-semibold");

        this.setState({
            BookingSystem: filters
        });
    };
    renderSuggestionVesselvalue(suggestion) {
        return <span>{suggestion}</span>;
    }

    getSuggestionVesselValue(suggestion) {
        return suggestion;
    }
    onSuggestionsFetchRequestedforvoyage = ({ value }) => {
        this.setState({
            suggestionsVoyage: this.voyageNameSuggestions(value)
        });
    };
    onSuggestionsFetchRequestedforcall = ({ value }) => {
        this.setState({
            suggestionsCalls: this.callSuggestions(value)
        });
    };
    callSuggestions(value) {
        if (this.state.BookingSystem.SelectedVesselCD != "" && this.state.BookingSystem.SelectedVesselCD != null && this.state.BookingSystem.SelectedVoyage != "" && this.state.BookingSystem.SelectedVoyage != null) {
            var VesselData = this.state.RefVessels;
            var inputValue = value.trim().toLowerCase();
            var inputLength = inputValue.length;
            var test = inputLength === 0 ? [] : VesselData.filter(tag => tag.VesselCd === this.state.BookingSystem.SelectedVesselCD
                && tag.VoyageNum === this.state.BookingSystem.SelectedVoyage && tag.CallNum.toLowerCase().slice(0, inputLength) === inputValue
            );
            //return test;
            return uniq(test.map(fence => fence.CallNum));
        }
        else
            return [];
    };
    voyageNameSuggestions(value) {
        if (this.state.BookingSystem.SelectedVesselCD != "" && this.state.BookingSystem.SelectedVesselCD != null) {
            var VesselData = this.state.RefVessels;
            var inputValue = value.trim().toLowerCase();
            var inputLength = inputValue.length;
            var test = inputLength === 0 ? [] : VesselData.filter(tag => tag.VesselCd === this.state.BookingSystem.SelectedVesselCD
                && tag.VoyageNum.toLowerCase().slice(0, inputLength) === inputValue
            );
            return uniq(test.map(fence => fence.VoyageNum));
        }
        else
            return [];
    };
    getvoyageNameSuggestions(value) {
        var VesselData = this.state.RefVessels;
        var inputValue = value.trim().toLowerCase();
        var inputLength = inputValue.length;
        var test = inputLength === 0 ? [] : VesselData.filter(tag =>
            tag.VesselCd.toLowerCase().slice(0, inputLength) === inputValue
        );
        return uniq(test.map(fence => fence.VoyageNum));
    };
    getcallSuggestions(value) {
        var VesselData = this.state.RefVessels;
        var inputValue = value.trim().toLowerCase();
        var inputLength = inputValue.length;
        var test = inputLength === 0 ? [] : VesselData.filter(tag => tag.VesselCd === this.state.BookingSystem.SelectedVesselCD
            && tag.VoyageNum.toLowerCase().slice(0, inputLength) === inputValue
        );
        return uniq(test.map(fence => fence.CallNum));
    };
    onSuggestionsClearRequestedforvoyage = () => {
        this.setState({
            suggestionsVoyage: []
        });
    };
    onSuggestionsClearRequestedforcall = () => {
        this.setState({
            suggestionsCalls: []
        });
    };
    onChangevoyage = (event, { newValue }) => {
        var filters = this.state.BookingSystem;
        filters.SelectedVoyage = newValue;
        //$('#vesselID').addClass("fw-semibold");
        filters.SelectedCall = '';
        this.setState({
            BookingSystem: filters
        });
        this.setState({
            suggestionsCalls: this.getcallSuggestions(newValue)
        });
    };
    renderSuggestionvoyagevalue(suggestion) {
        return <span>{suggestion}</span>;
    }

    getSuggestionvoyageValue(suggestion) {
        return suggestion;
    }
    renderSuggestioncallvalue(suggestion) {
        return <span>{suggestion}</span>;
    }

    getSuggestioncallValue(suggestion) {
        return suggestion;
    }

    onSuggestionsFetchRequestedforArrvessel = ({ value }) => {
        this.setState({
            ArrsuggestionsVesselId: this.getArrvesselNameSuggestions(value)
        });
    };
    getArrvesselNameSuggestions(value) {
        //var vessels = this.state.RefVessels;
        var VesselData = this.state.RefVessels.map(fence => fence.VesselCd);
        var vessels = uniq(VesselData);
        var inputValue = value.trim().toLowerCase();
        var inputLength = inputValue.length;
        return inputLength === 0 ? [] : vessels.filter(tag =>
            tag.toLowerCase().slice(0, inputLength) === inputValue
        );
    };
    onSuggestionsClearRequestedforArrvessel = () => {
        this.setState({
            ArrsuggestionsVesselId: []
        });
    };
    onChangeArrVesselId = (event, { newValue }) => {
        var filters = this.state.BookingSystem;
        filters.ArrSelectedVesselCD = newValue;
        filters.ArrSelectedVoyage = '';
        filters.ArrSelectedCall = '';

        this.setState({
            BookingSystem: filters
        });
        this.setState({
            ArrsuggestionsVoyage: this.getArrvoyageNameSuggestions(newValue)
        });
    };
    onChangArrcall = (event, { newValue }) => {
        var filters = this.state.BookingSystem;
        filters.ArrSelectedCall = newValue;

        this.setState({
            BookingSystem: filters
        });
    };
    renderSuggestionArrVesselvalue(suggestion) {
        return <span>{suggestion}</span>;
    }

    getSuggestionArrVesselValue(suggestion) {
        return suggestion;
    }
    onSuggestionsFetchRequestedforArrvoyage = ({ value }) => {
        this.setState({
            ArrsuggestionsVoyage: this.ArrvoyageNameSuggestions(value)
        });
    };
    onSuggestionsFetchRequestedforArrcall = ({ value }) => {
        this.setState({
            ArrsuggestionsCalls: this.ArrcallSuggestions(value)
        });
    };
    ArrcallSuggestions(value) {
        if (this.state.BookingSystem.ArrSelectedVesselCD != "" && this.state.BookingSystem.ArrSelectedVesselCD != null && this.state.BookingSystem.ArrSelectedVoyage != "" && this.state.BookingSystem.ArrSelectedVoyage != null) {
            var VesselData = this.state.RefVessels;
            var inputValue = value.trim().toLowerCase();
            var inputLength = inputValue.length;
            var test = inputLength === 0 ? [] : VesselData.filter(tag => tag.VesselCd === this.state.BookingSystem.ArrSelectedVesselCD
                && tag.VoyageNum === this.state.BookingSystem.ArrSelectedVoyage && tag.CallNum.toLowerCase().slice(0, inputLength) === inputValue
            );
            //return test;
            return uniq(test.map(fence => fence.CallNum));
        }
        else
            return [];
    };
    ArrvoyageNameSuggestions(value) {
        if (this.state.BookingSystem.ArrSelectedVesselCD != "" && this.state.BookingSystem.ArrSelectedVesselCD != null) {
            var VesselData = this.state.RefVessels;
            var inputValue = value.trim().toLowerCase();
            var inputLength = inputValue.length;
            var test = inputLength === 0 ? [] : VesselData.filter(tag => tag.VesselCd === this.state.BookingSystem.ArrSelectedVesselCD
                && tag.VoyageNum.toLowerCase().slice(0, inputLength) === inputValue
            );
            return uniq(test.map(fence => fence.VoyageNum));
        }
        else
            return [];
    };
    getArrvoyageNameSuggestions(value) {
        var VesselData = this.state.RefVessels;
        var inputValue = value.trim().toLowerCase();
        var inputLength = inputValue.length;
        var test = inputLength === 0 ? [] : VesselData.filter(tag =>
            tag.VesselCd.toLowerCase().slice(0, inputLength) === inputValue
        );
        return uniq(test.map(fence => fence.VoyageNum));
    };
    getArrcallSuggestions(value) {
        var VesselData = this.state.RefVessels;
        var inputValue = value.trim().toLowerCase();
        var inputLength = inputValue.length;
        var test = inputLength === 0 ? [] : VesselData.filter(tag => tag.VesselCd === this.state.BookingSystem.ArrSelectedVesselCD
            && tag.VoyageNum.toLowerCase().slice(0, inputLength) === inputValue
        );
        return uniq(test.map(fence => fence.CallNum));
    };
    onSuggestionsClearRequestedforArrvoyage = () => {
        this.setState({
            ArrsuggestionsVoyage: []
        });
    };
    onSuggestionsClearRequestedforArrcall = () => {
        this.setState({
            ArrsuggestionsCalls: []
        });
    };
    onChangeArrvoyage = (event, { newValue }) => {
        var filters = this.state.BookingSystem;
        filters.ArrSelectedVoyage = newValue;
        //$('#vesselID').addClass("fw-semibold");
        filters.ArrSelectedCall = '';
        this.setState({
            BookingSystem: filters
        });
        this.setState({
            ArrsuggestionsCalls: this.getArrcallSuggestions(newValue)
        });
    };
    renderSuggestionArrvoyagevalue(suggestion) {
        return <span>{suggestion}</span>;
    }

    getSuggestionArrvoyageValue(suggestion) {
        return suggestion;
    }
    renderSuggestionArrcallvalue(suggestion) {
        return <span>{suggestion}</span>;
    }

    getSuggestionArrcallValue(suggestion) {
        return suggestion;
    }

    //RCNG-33 End

    public render() {
        //const { checked, expanded } = this.state;

        var Voyagedisabled: any;
        var Calldisabled: any;
        
        if (this.state.BookingSystem.SelectedVesselCD != "" && this.state.BookingSystem.SelectedVesselCD != null) {
            Voyagedisabled = false;
            Calldisabled = true;
        }
        else {
            Voyagedisabled = true;
            Calldisabled = true;
        }
        if (this.state.BookingSystem.SelectedVoyage != "" && this.state.BookingSystem.SelectedVoyage != null) {
            //RCNG-140
            var selectedVessel = this.state.RefVessels.filter(x => x.VesselCd.toUpperCase() == this.state.BookingSystem.SelectedVesselCD.toUpperCase());
            if (selectedVessel != null && selectedVessel != undefined && selectedVessel.length > 0) {
                var vesselHasVoyageCalls = selectedVessel[0].VoyagesHaveCalls;
                if (vesselHasVoyageCalls)
                    Calldisabled = false;
                else
                    Calldisabled = true;
            }
        }
        else {
            Calldisabled = true;
        }
        var ArrVoyagedisabled: any;
        var ArrCalldisabled: any;
        if (this.state.BookingSystem.ArrSelectedVesselCD != "" && this.state.BookingSystem.ArrSelectedVesselCD != null) {
            ArrVoyagedisabled = false;
            ArrCalldisabled = true;
        }
        else {
            ArrVoyagedisabled = true;
            ArrCalldisabled = true;
        }
        if (this.state.BookingSystem.ArrSelectedVoyage != "" && this.state.BookingSystem.ArrSelectedVoyage != null) {
            //RCNG-140
            var selectedVessel = this.state.RefVessels.filter(x => x.VesselCd.toUpperCase() == this.state.BookingSystem.ArrSelectedVesselCD.toUpperCase());
            if (selectedVessel != null && selectedVessel != undefined && selectedVessel.length > 0) {
                var vesselHasVoyageCalls = selectedVessel[0].VoyagesHaveCalls;
                if (vesselHasVoyageCalls)
                    ArrCalldisabled = false;
                else
                    ArrCalldisabled = true;
            }
        }
        else {
            ArrCalldisabled = true;
        }
        const { checked, expanded, suggestionsVesselId, suggestionsVoyage, suggestionsCalls, ArrsuggestionsVesselId, ArrsuggestionsVoyage, ArrsuggestionsCalls } = this.state;

        const FenceIdListinputPropsforvessel = {
            id: 'vesselID',
            placeholder: 'Vessel',
            value: this.state.BookingSystem.SelectedVesselCD,
            onChange: this.onChangeVesselId.bind(this),
            //readOnly: true //RCNG 94 //RCNG-109
        };
        const FenceIdListinputPropsforvoyage = {
            id: 'voyageNum',
            placeholder: 'Voyage',
            value: this.state.BookingSystem.SelectedVoyage,
            onChange: this.onChangevoyage.bind(this),
            disabled: Voyagedisabled,
            //readOnly: true //RCNG 94 //RCNG-109
        };
        const FenceIdListinputPropsforcall = {
            id: 'CallNum',
            placeholder: 'Call',
            value: this.state.BookingSystem.SelectedCall,
            onChange: this.onChangcall.bind(this),
            disabled: Calldisabled,
            //  readOnly: true //RCNG 94
        };
        const FenceIdListinputPropsforArrvessel = {
            id: 'vesselID',
            placeholder: 'Vessel',
            value: this.state.BookingSystem.ArrSelectedVesselCD,
            onChange: this.onChangeArrVesselId.bind(this),
            // readOnly: true //RCNG 94
        };
        const FenceIdListinputPropsforArrvoyage = {
            id: 'voyageNum',
            placeholder: 'Voyage',
            value: this.state.BookingSystem.ArrSelectedVoyage,
            onChange: this.onChangeArrvoyage.bind(this),
            disabled: ArrVoyagedisabled,
            //readOnly: true //RCNG 94
        };
        const FenceIdListinputPropsforArrcall = {
            id: 'CallNum',
            placeholder: 'Call',
            value: this.state.BookingSystem.ArrSelectedCall,
            onChange: this.onChangArrcall.bind(this),
            disabled: ArrCalldisabled,
            //readOnly: true //RCNG 94
        };
        return <div id="AssignBookingDiv" hidden={this.state.isLoading}>
            <div className='well' hidden={true}>
                <div className="row">
                    <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                        <span className='float-end col-form-label'>Reefer ID:</span>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-7 col-xs-7">
                        <div className='input-group col-form-label'>
                            {(this.state.BookingSystem != undefined) ? this.state.BookingSystem.reeferID : ''}
                        </div>
                    </div>
                </div>
                <div className="row mt-2 ">
                    <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                        <span className='float-end col-form-label'>Booking #:</span>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-7 col-xs-7">
                        <div className={(this.state.BookingSystem != undefined && this.state.BookingSystem.IsEdit) ? 'input-group col-form-label' : 'input - group'}>
                            {(this.state.BookingSystem != undefined && this.state.BookingSystem.IsEdit) ? this.state.BookingSystem.BookingNumber :
                                <input type='text' id='txtBookingId' value={this.state.BookingSystem.BookingNumber} onChange={this.BookingNumberChange.bind(this)} className='form-control' maxLength={15} placeholder='Booking Number' />
                            }
                        </div>                        
                    </div>
                </div>
                <div className="row mt-2">
                    <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                        <span className='float-end col-form-label'>Temperature Unit:</span>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-7 col-xs-7">
                        <div className='input-group'>
                            <select className='form-control' value={this.state.BookingSystem.BookedTemperatureUnit} onChange={this.Temperaturechange.bind(this)} >
                                <option value="">Temperature Unit</option>
                                {
                                    this.state.RefTemperatureUnit.map((unit, index) =>
                                        <option key={unit.TemperatureUnitCd + index} value={unit.TemperatureUnitCd}>{unit.TemperatureUnitDesc}</option>
                                    )}
                            </select>
                        </div>
                    </div>
                </div>
                <div className="row mt-2" >
                    <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4" >
                        <span className='float-end col-form-label'>Booked Temperature:</span>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-7 col-xs-7" >
                        <div className='input-group'>
                            <input type='text' id='txtBookedTemperature' value={this.state.BookingSystem.BookedTemperature} onChange={this.BookingTemperatureChange.bind(this)} className='form-control' placeholder='Booked Temperature' />
                        </div>
                    </div>
                </div>

                <div className="row mt-2">
                    <div className="col-md-3 pe-0 text-md-end"><label className='col-form-label'>Departing VVC: </label></div>
                    <div className="col-md-3">
                        <Autosuggest name="vesselID" id="vesselID"
                            suggestions={suggestionsVesselId}
                            onSuggestionsFetchRequested={this.onSuggestionsFetchRequestedforvessel}
                            onSuggestionsClearRequested={this.onSuggestionsClearRequestedforvessel}
                            getSuggestionValue={this.getSuggestionVesselValue}
                            renderSuggestion={this.renderSuggestionVesselvalue}
                            inputProps={FenceIdListinputPropsforvessel}
                            highlightFirstSuggestion={true}
                        />
                    </div>
                    <div className="col-md-3">
                        <Autosuggest name="voyage" id="voyage"
                            suggestions={suggestionsVoyage}
                            onSuggestionsFetchRequested={this.onSuggestionsFetchRequestedforvoyage}
                            onSuggestionsClearRequested={this.onSuggestionsClearRequestedforvoyage}
                            getSuggestionValue={this.getSuggestionvoyageValue}
                            renderSuggestion={this.renderSuggestionvoyagevalue}
                            inputProps={FenceIdListinputPropsforvoyage}
                            highlightFirstSuggestion={true}
                        />
                    </div>
                    <div className="col-md-3">
                        <Autosuggest name="Call" id="Call"
                            suggestions={suggestionsCalls}
                            onSuggestionsFetchRequested={this.onSuggestionsFetchRequestedforcall}
                            onSuggestionsClearRequested={this.onSuggestionsClearRequestedforcall}
                            getSuggestionValue={this.getSuggestioncallValue}
                            renderSuggestion={this.renderSuggestioncallvalue}
                            inputProps={FenceIdListinputPropsforcall}
                            highlightFirstSuggestion={true}
                        />
                    </div>

                </div>
                <div className="row mt-2">
                    <div className="col-md-3 pe-0 text-md-end"><label className='col-form-label'>Arriving VVC: </label></div>
                    <div className="col-md-3">
                        <Autosuggest name="ArrvesselID" id="ArrvesselID"
                            suggestions={ArrsuggestionsVesselId}
                            onSuggestionsFetchRequested={this.onSuggestionsFetchRequestedforArrvessel}
                            onSuggestionsClearRequested={this.onSuggestionsClearRequestedforArrvessel}
                            getSuggestionValue={this.getSuggestionArrVesselValue}
                            renderSuggestion={this.renderSuggestionArrVesselvalue}
                            inputProps={FenceIdListinputPropsforArrvessel}
                            highlightFirstSuggestion={true}
                        />
                    </div>
                    <div className="col-md-3">
                        <Autosuggest name="Arrvoyage" id="Arrvoyage"
                            suggestions={ArrsuggestionsVoyage}
                            onSuggestionsFetchRequested={this.onSuggestionsFetchRequestedforArrvoyage}
                            onSuggestionsClearRequested={this.onSuggestionsClearRequestedforArrvoyage}
                            getSuggestionValue={this.getSuggestionArrvoyageValue}
                            renderSuggestion={this.renderSuggestionArrvoyagevalue}
                            inputProps={FenceIdListinputPropsforArrvoyage}
                            highlightFirstSuggestion={true}
                        />
                    </div>
                    <div className="col-md-3">
                        <Autosuggest name="ArrCall" id="ArrCall"
                            suggestions={ArrsuggestionsCalls}
                            onSuggestionsFetchRequested={this.onSuggestionsFetchRequestedforArrcall}
                            onSuggestionsClearRequested={this.onSuggestionsClearRequestedforArrcall}
                            getSuggestionValue={this.getSuggestionArrcallValue}
                            renderSuggestion={this.renderSuggestionArrcallvalue}
                            inputProps={FenceIdListinputPropsforArrcall}
                            highlightFirstSuggestion={true}
                        />
                    </div>
                </div>
            </div>
            <div id="CustomerAccessDiv" hidden={this.state.IsCustomerAccessHide}>
                <div className="card text-bg-light mt-3">
                    <div className="card-header"> Customer Access </div>
                    <div className="card-body custom-treeview max-height-20rem">
                        {this.state.CustomerGroups.length > 0 ? <CheckboxTree
                            checked={checked}
                            expanded={expanded}
                            nodes={this.state.CustomerGroups}
                            onCheck={this.onCheck}
                            onExpand={this.onExpand}
                            showNodeIcon={false}
                        /> : null}
                    </div>
                </div>
            </div>
            <div className="modal-footer">
                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal" onClick={this.CloseModal.bind(this)}>Cancel</button>
                <button type="button" className="btn btn-primary" onClick={this.submitAssignBookingConfirm.bind(this)}>Save</button>
               
            </div>
        </div>
    }
}

export class UnAssignBookingSystem extends React.Component<any, BookingSystemState> {    
    constructor(props: any) {
        super(props);
        this.state = {
            SelectedReefers: [], BookingSystem: newBookingSystem, RefTemperatureUnit: [], isLoading: true, collapsed: false, CustomerGroups: [], checked: [], expanded: [], CustomerGroupsList: [], IsCustomerAccessHide: true, UnassignOption: '', lbl3rdPartyDisabled: false, lblBookingDisabled: false, lblBothDisabled: false, IsCommandIssued: false, PrevSelectedItems: []
            , RefVessels: [], suggestionsVesselId: [], suggestionsVoyage: [], suggestionsCalls: [], ArrsuggestionsVesselId: [], ArrsuggestionsVoyage: [], ArrsuggestionsCalls: []           };
        lastCheckedNodes = [];
        selReefers = this.props.reeferData;
    }

    getRefTemperatureUnit() {
        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/reeferstatus/GetRefTemperatureUnit')
        RCUtils.fetchFaultRetry(request)
            .then(RCUtils.handleResponse)
            .then(response => response.json() as Promise<server.RefTemperatureUnit[]>)
            .then(data => {
                this.setState({ RefTemperatureUnit: data });
            });
    }

    componentDidMount() {
        var reeferData = this.props.reeferData;
        var EventMasterList = this.props.reeferFormatter.EventMasterList;
        if (reeferData != undefined && reeferData != null && reeferData.length > 0) {
            var eventDescription = lodashfilter(EventMasterList, function (item) {
                return item.EventMasterID === reeferData[0].EventMasterID;
            });
            if (eventDescription.length > 0 && eventDescription != null) {
                var EventCd = eventDescription[0].EventCd;
            }
            var IsAssignTo3P;
            if (reeferData != null && reeferData != undefined) {
                
                if (reeferData[0].CustomerName != "" && reeferData[0].BookingNumber == null && reeferData[0].BookingNumber == '') {
                    if (reeferData[0].CustomerName === JSON.parse(sessionStorage.getItem('customerDetails')).CustomerName) {
                        IsAssignTo3P = false;
                    } else {
                        IsAssignTo3P = true;
                    }
                }
                else if (reeferData[0].BookingNumber == null){
                    if (reeferData[0].CustomerName === JSON.parse(sessionStorage.getItem('customerDetails')).CustomerName) {
                        IsAssignTo3P = false;
                    } else {
                        IsAssignTo3P = true;
                    }
                }
            }
            this.setState({ SelectedReefers: reeferData }, () => { this.bindUnassignData(this.props.CustomerAccessData,EventCd,IsAssignTo3P); });
            this.getRefTemperatureUnit();
            var TemperatureUnitCd = "";
            var unassignMode = "";            
            var bookingSystem: server.BookingSystem_UIModel = JSON.parse(JSON.stringify(this.state.BookingSystem));
            bookingSystem.reeferID = reeferData[0].ReeferID;
            if (reeferData[0].BookingNumber != null && reeferData[0].BookingNumber != "" && !this.ValidateBookingID(reeferData)) {
                if (reeferData[0].TemperatureUnit != null) {
                    var _lststrValue = reeferData[0].TemperatureUnit.toString().trim().split('@');
                    var BookedTemperature = parseFloat(_lststrValue[0]);
                    var temperatureCd = _lststrValue[1];
                }
                if (temperatureCd == "F")
                    TemperatureUnitCd = "Fahrenheit";
                else if (temperatureCd == "C")
                    TemperatureUnitCd = "Celsius";

                bookingSystem.BookedTemperatureUnit = TemperatureUnitCd;
                bookingSystem.BookingNumber = reeferData[0].BookingNumber;
                bookingSystem.BookedTemperature = BookedTemperature != undefined ? BookedTemperature.toString() : '';              
            }    
            this.setState({ BookingSystem: bookingSystem });
        }
    }    

    onExpand(expanded) {
        this.setState({ expanded: expanded });
    }

    submitUnAssignCommand() {
        $('#globalLoader').show();
        this.state.BookingSystem.RcdmasterId = this.state.SelectedReefers[0].RCDMasterID;
        this.state.BookingSystem.Unitmasterid = this.state.SelectedReefers[0].UnitMasterID;
        this.state.BookingSystem.CustomerId = this.state.SelectedReefers[0].CustomerID;
        this.state.BookingSystem.UserId = this.props.UserID;
        this.state.BookingSystem.eventmasteridForAssign = 0;
        this.state.BookingSystem.eventmasteridforupdate = 0;
        this.state.BookingSystem.EventDtm = this.state.SelectedReefers[0].EventDTTM;
        this.state.BookingSystem.RCDReportingInterval = this.state.SelectedReefers[0].RCDReportingInterval;
        this.state.BookingSystem.SetPoint = this.state.SelectedReefers[0].SetPoint;

        var checkedGroupIds = [];
        var selUnits = [];
        var checkedList = this.state.checked;

        if (this.state.SelectedReefers.length > 1) {
            $.each(this.state.SelectedReefers, function (index, value) {
                selectedUnits = selectedUnits == "" ? value.UnitMasterID : selectedUnits + "," + value.UnitMasterID;
            });
        }
        else {
            selectedUnits = this.state.SelectedReefers[0].UnitMasterID.toString();
        }

        $.each(selectedUnits.split(','), function (index, value) {
            selUnits.push(parseInt(value));
        });

        $.each(checkedList, function (index, value) {            
            checkedGroupIds.push(parseInt(value.split(':')[1].split('_')[0]));
        });

        this.state.BookingSystem.SelectedUnits = selUnits;
        this.state.BookingSystem.Groups = checkedGroupIds;
        this.state.BookingSystem.UnassignMode = this.state.UnassignOption;

        var bookingSystem = JSON.stringify(this.state.BookingSystem);
        var url = Config.ApiBaseUrl + '/api/reeferstatus/UnAssignBookingdetails';
        var request = RCUtils.FetchRequest(url, { method: 'POST', body: bookingSystem, headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json())
            .then(data => {
                $('#globalLoader').hide();
                if (data == 'Reefer unassigned successfully.') {                    
                    $("#contextMenuModel .btn-close").click(); 
                    if (this.state.BookingSystem.UnassignMode == "UnassignBooking")
                        data = "Reefer unassigned from Booking successfully.";
                    if (this.state.BookingSystem.UnassignMode == "Unassign3rdParty")
                        data = "Reefer unassigned from Customer Access successfully.";
                    if (this.state.BookingSystem.UnassignMode == "UnassignBoth")
                        data = "Reefer unassigned from both Booking and Customer Access successfully.";
                    this.setState({ IsCommandIssued: true, PrevSelectedItems: this.props.reeferData }, () => { this.props.IsCommandIssued(this.state.IsCommandIssued); this.props.PrevSelectedItems(this.props.reeferData) });
                    this.props.refreshStatusGrid();
                    PopupWindow.showErrorMessage("Booking and Access", data);
                    
                }
                else {
                    PopupWindow.showErrorMessage("Booking and Access", data);
                }
            });

    }

    bindUnassignData(customerAccessData: any, EventCd: string, IsAssignTo3P:boolean) {
        if (customerAccessData != undefined) {
            this.setState({ CustomerGroups: JSON.parse(JSON.stringify(customerAccessData)), CustomerGroupsList: customerAccessData });
            if (customerAccessData.length > 0) {
                var defaultChecked = [];
                var defaultExpand = [];
                $.each(customerAccessData, function (index, value) {
                    if (value.isSelected == true) {
                        defaultExpand.push(value.value);
                    }
                    $.each(value.children, function (ind, val) {
                        if (val.isSelected == true) {
                            defaultChecked.push(val.value);
                        }
                    });
                });
                this.setState({ isLoading: false, IsCustomerAccessHide: false, checked: defaultChecked, expanded: defaultExpand }, () => { return lastCheckedNodes = this.state.checked, this.updateUnassginModel(EventCd, IsAssignTo3P) });

            }
            else {
                lastCheckedNodes = [];
                this.setState({ isLoading: false, checked: [], expanded: [], CustomerGroups: [], CustomerGroupsList: [], IsCustomerAccessHide: true }, () => this.updateUnassginModel(EventCd, IsAssignTo3P));
            }
        }
    }

    componentWillReceiveProps(nextprops: any) {     
        var reeferData = nextprops.reeferData;  
        var EventMasterList = nextprops.reeferFormatter.EventMasterList;

        if (reeferData != undefined && reeferData != null && reeferData.length > 0) {
            var eventDescription = lodashfilter(EventMasterList, function (item) {
                return item.EventMasterID === reeferData[0].EventMasterID;
            });
            if (eventDescription.length > 0 && eventDescription != null) {
               var EventCd = eventDescription[0].EventCd;
            }
            var IsAssignTo3P;
            if (reeferData != null && reeferData != undefined) {
                
                if (reeferData[0].CustomerName != "" && reeferData[0].BookingNumber == null && reeferData[0].BookingNumber == '') {
                    if (reeferData[0].CustomerName === JSON.parse(sessionStorage.getItem('customerDetails')).CustomerName) {
                        IsAssignTo3P = false;
                    } else {
                        IsAssignTo3P = true;
                    }
                }
                else if (reeferData[0].BookingNumber == null) {
                    if (reeferData[0].CustomerName === JSON.parse(sessionStorage.getItem('customerDetails')).CustomerName) {
                        IsAssignTo3P = false;
                    } else {
                        IsAssignTo3P = true;
                    }
                }
            }

            this.setState({ SelectedReefers: reeferData }, () => { this.bindUnassignData(nextprops.CustomerAccessData, EventCd, IsAssignTo3P); });
            this.getRefTemperatureUnit();
            var TemperatureUnitCd = "";
            var unassignMode = "";    
            var bookingSystem: server.BookingSystem_UIModel = JSON.parse(JSON.stringify(this.state.BookingSystem));
            bookingSystem.reeferID = reeferData[0].ReeferID;
            if (reeferData[0].BookingNumber != null && reeferData[0].BookingNumber != "" && !this.ValidateBookingID(reeferData)) {
                if (reeferData[0].TemperatureUnit != null) {
                    var _lststrValue = reeferData[0].TemperatureUnit.toString().trim().split('@');
                    var BookedTemperature = parseFloat(_lststrValue[0]);
                    var temperatureCd = _lststrValue[1];
                }
                if (temperatureCd == "F")
                    TemperatureUnitCd = "Fahrenheit";
                else if (temperatureCd == "C")
                    TemperatureUnitCd = "Celsius";
                bookingSystem.BookedTemperatureUnit = TemperatureUnitCd;
                bookingSystem.BookingNumber = reeferData[0].BookingNumber;
                bookingSystem.BookedTemperature = BookedTemperature != undefined ? BookedTemperature.toString() : '';                
            }            
            this.setState({ BookingSystem: bookingSystem });      
        }        
    }


    CloseModal() {
        lastCheckedNodes = [];
        this.setState({ checked: lastCheckedNodes });
    } 

    updateUnassginModel(EventCd: string, IsAssignTo3P: boolean) {
        
        if (EventCd === "BDR" || IsAssignTo3P) {
            this.setState({ lbl3rdPartyDisabled: false, lblBookingDisabled: true, lblBothDisabled: true, UnassignOption: "Unassign3rdParty" },
                () => { this.UnassignModeChange(this.state.UnassignOption) });
        }
        else if (this.state.SelectedReefers[0].BookingNumber != null && this.state.SelectedReefers[0].BookingNumber != '' && !this.ValidateBookingID(this.state.SelectedReefers) && this.state.checked.length > 0)
            this.setState({ lbl3rdPartyDisabled: false, lblBookingDisabled: false, lblBothDisabled: false, UnassignOption: "UnassignBoth" },
                () => { this.UnassignModeChange(this.state.UnassignOption) });
        else if (this.state.BookingSystem.BookingNumber != null && this.state.BookingSystem.BookingNumber != '' && !this.ValidateBookingID(this.state.SelectedReefers))
            this.setState({ lbl3rdPartyDisabled: true, lblBookingDisabled: false, lblBothDisabled: true, UnassignOption: "UnassignBooking" },
                () => { this.UnassignModeChange(this.state.UnassignOption) });
        else
            this.setState({ lbl3rdPartyDisabled: false, lblBookingDisabled: true, lblBothDisabled: true, UnassignOption: "Unassign3rdParty" },
                () => { this.UnassignModeChange(this.state.UnassignOption) });
    }

    UnassignModeChange(value) {       
        if (!this.state.lbl3rdPartyDisabled && this.state.lblBookingDisabled && this.state.lblBothDisabled) {
            if ($("#lblUnassignBooking").hasClass("active")) $('#lblUnassignBooking').removeClass('active');
            if ($("#lblUnassignBoth").hasClass("active")) $('#lblUnassignBoth').removeClass('active');
            if (!$("#lblUnassign3rdParty").hasClass("active")) $('#lblUnassign3rdParty').addClass('active');
        }
        if (!this.state.lblBookingDisabled && this.state.lbl3rdPartyDisabled && this.state.lblBothDisabled) {
            if (!$("#lblUnassignBooking").hasClass("active")) $('#lblUnassignBooking').addClass('active');
            if ($("#lblUnassignBoth").hasClass("active")) $('#lblUnassignBoth').removeClass('active');
            if ($("#lblUnassign3rdParty").hasClass("active")) $('#lblUnassign3rdParty').removeClass('active');
        }

        if (value == "UnassignBooking" && !this.state.lblBookingDisabled) {
            if (!$("#lblUnassignBooking").hasClass("active")) $('#lblUnassignBooking').addClass('active');          
            if ($("#lblUnassign3rdParty").hasClass("active")) $('#lblUnassign3rdParty').removeClass('active');
            if ($("#lblUnassignBoth").hasClass("active")) $('#lblUnassignBoth').removeClass('active');            
            this.setState({ UnassignOption: value });
        }
        if (value == "Unassign3rdParty" && !this.state.lbl3rdPartyDisabled) {
            if (!$("#lblUnassign3rdParty").hasClass("active")) $('#lblUnassign3rdParty').addClass('active');
            if ($("#lblUnassignBooking").hasClass("active")) $('#lblUnassignBooking').removeClass('active');
            if ($("#lblUnassignBoth").hasClass("active")) $('#lblUnassignBoth').removeClass('active');                       
            this.setState({ UnassignOption: value });
        }
        if (value == "UnassignBoth" && !this.state.lblBothDisabled) {
            if (!$("#lblUnassignBoth").hasClass("active")) $('#lblUnassignBoth').addClass('active');
            if ($("#lblUnassign3rdParty").hasClass("active")) $('#lblUnassign3rdParty').removeClass('active');
            if ($("#lblUnassignBooking").hasClass("active")) $('#lblUnassignBooking').removeClass('active');
            this.setState({ UnassignOption: value });
        }        
    } 

    ValidateBookingID(reeferData: any) {
        if (reeferData.length > 0 && reeferData[0].LastBookingEventMasterId != null && reeferData[0].LastBookingEventMasterId.length > 0) {
            for (var lastBookingID in reeferData[0].LastBookingEventMasterId) {
                if (reeferData[0].EventMasterID == parseInt(reeferData[0].LastBookingEventMasterId[lastBookingID])) {
                    return true;
                }
            }
        }
        return false;
    }

    public render() {
        const { checked, expanded } = this.state;
        return <div>
            <div id="UnAssignBookingDiv" hidden={this.state.isLoading}>
                <div className='well'>
                    <div className="row" >
                        <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4" >
                            <span className='float-end col-form-label'>Reefer ID:</span>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-7 col-xs-7" >
                            <div className='input-group col-form-label'>
                                {(this.state.BookingSystem != undefined) ? this.state.BookingSystem.reeferID : ''}
                            </div>
                        </div>
                    </div>
                    <div className="row mt-2" >
                        <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4" >
                            <span className='float-end col-form-label'>Booking #:</span>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-7 col-xs-7" >
                            <div className='input-group col-form-label'>
                                {(this.state.BookingSystem != undefined) ? this.state.BookingSystem.BookingNumber : ''}
                            </div>
                        </div>
                    </div>
                </div>
                <div id="CustomerAccessDiv" hidden={this.state.IsCustomerAccessHide}>
                    <div className="card text-bg-light mt-3">
                        <div className="card-header"> Customer Access </div>
                        <div className="card-body custom-treeview max-height-20rem">
                            {this.state.CustomerGroups.length > 0 ? <CheckboxTree
                                checked={checked}
                                expanded={expanded}
                                nodes={this.state.CustomerGroups}
                                showNodeIcon={false}
                                disabled={true}
                            /> : null}
                        </div>
                    </div>

                    <div className="btn-group booking-radio-group" data-toggle="buttons">
                        <label className="btn btn-secondary" id="lblUnassignBooking" onClick={(e) => this.UnassignModeChange('UnassignBooking')}>
                            <input type="radio" name="options" id="option1" value="UnassignBooking" /> Unassign booking only
                        </label>
                        <label className="btn btn-secondary" id="lblUnassign3rdParty" onClick={(e) => this.UnassignModeChange('Unassign3rdParty')}>
                            <input type="radio" name="options" id="option2" value="Unassign3rdParty" /> Unassign third-party access only
                        </label>
                        <label className="btn btn-secondary active" id="lblUnassignBoth" onClick={(e) => this.UnassignModeChange('UnassignBoth')}>
                            <input type="radio" name="options" id="option3" value="UnassignBoth" /> Unassign both
                        </label>
                    </div>
                </div>
                <div className="modal-footer">
                    <button type="button" className="btn btn-secondary" data-bs-dismiss="modal" onClick={this.CloseModal.bind(this)}>Cancel</button>
                    <button type="button" className="btn btn-primary" onClick={this.submitUnAssignCommand.bind(this)}>Save</button>
                    
                </div>
            </div>
        </div>
    }
}

export class EditBookingSystem extends React.Component<any, BookingSystemState> {
    constructor(props: any) {
        super(props);
        this.state = {
            SelectedReefers: [], BookingSystem: newBookingSystem, RefTemperatureUnit: [], isLoading: true, collapsed: false, CustomerGroups: [], checked: [], expanded: [], CustomerGroupsList: [], IsCustomerAccessHide: true, UnassignOption: '', lbl3rdPartyDisabled: false, lblBookingDisabled: false, lblBothDisabled: false, IsCommandIssued: false, PrevSelectedItems: []
            , RefVessels: [], suggestionsVesselId: [], suggestionsVoyage: [], suggestionsCalls: [], ArrsuggestionsVesselId: [], ArrsuggestionsVoyage: [], ArrsuggestionsCalls: []           };
    }

    getRefTemperatureUnit() {
        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/reeferstatus/GetRefTemperatureUnit')
        RCUtils.fetchFaultRetry(request)
            .then(RCUtils.handleResponse)
            .then(response => response.json() as Promise<server.RefTemperatureUnit[]>)
            .then(data => {
                this.setState({ RefTemperatureUnit: data });
            });
    }

    componentDidMount() {
        var reeferData = this.props.reeferData;
        if (reeferData != undefined && reeferData != null) {
            this.bindEditData();
            this.setState({ SelectedReefers: reeferData });
        }
    }

    submitBookingDetails() {
        $('#globalLoader').show();
        //var bookingSystem: server.BookingSystem_UIModel = JSON.parse(JSON.stringify(this.state.BookingSystem));
        this.state.BookingSystem.RcdmasterId = this.state.SelectedReefers[0].RCDMasterID;
        this.state.BookingSystem.Unitmasterid = this.state.SelectedReefers[0].UnitMasterID;
        this.state.BookingSystem.CustomerId = this.state.SelectedReefers[0].CustomerID;
        this.state.BookingSystem.UserId = this.props.UserID;
        this.state.BookingSystem.eventmasteridForAssign = 0;
        this.state.BookingSystem.eventmasteridforupdate = 0;
        this.state.BookingSystem.EventDtm = this.state.SelectedReefers[0].EventDTTM;
        this.state.BookingSystem.RCDReportingInterval = this.state.SelectedReefers[0].RCDReportingInterval;
        this.state.BookingSystem.SetPoint = this.state.SelectedReefers[0].SetPoint;
        var bookingSystem = JSON.stringify(this.state.BookingSystem);
        var url = Config.ApiBaseUrl + '/api/reeferstatus/UpdateBookingdetails';
        var request = RCUtils.FetchRequest(url, { method: 'POST', body: bookingSystem, headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json())
            .then(data => {
                $('#globalLoader').hide();
                if (data == 'Booking updated successfully.') {
                    $("#contextMenuModel .btn-close").click();
                    this.setState({ IsCommandIssued: true, PrevSelectedItems: this.props.reeferData }, () => { this.props.IsCommandIssued(this.state.IsCommandIssued); this.props.PrevSelectedItems(this.props.reeferData) });
                    this.props.refreshStatusGrid();
                    PopupWindow.showErrorMessage("Booking", data);
                    
                }
                else {
                    PopupWindow.showErrorMessage("Booking", data);
                }
            });
    }

    Temperaturechange(event: React.FormEvent<HTMLSelectElement>) {
        var Value: string = event.currentTarget.value;
        var bookingSystem: server.BookingSystem_UIModel = JSON.parse(JSON.stringify(this.state.BookingSystem));
        bookingSystem.BookedTemperatureUnit = Value;
        this.setState({ BookingSystem: bookingSystem });
    }

    bindEditData() {
        var reeferData = this.props.reeferData;
        if (reeferData != undefined && reeferData != null && reeferData.length > 0) {
            this.getRefTemperatureUnit();
            var bookingSystem: server.BookingSystem_UIModel = JSON.parse(JSON.stringify(this.state.BookingSystem));
            bookingSystem.reeferID = reeferData[0].ReeferID;
            if (reeferData[0].TemperatureUnit != null) {
                var _lststrValue = reeferData[0].TemperatureUnit.toString().trim().split('@');
                var temperatureCd = _lststrValue[1];
            }
            bookingSystem.BookedTemperatureUnit = temperatureCd != undefined ? temperatureCd : "C";
            bookingSystem.BookingNumber = reeferData[0].BookingNumber;
            bookingSystem.BookedTemperature = reeferData[0].BookedTemperature != null ? reeferData[0].BookedTemperature : '';
            this.setState({ SelectedReefers: reeferData, BookingSystem: bookingSystem });
        }
    }
    componentWillReceiveProps(nextprops: any) {       
        var reeferData = nextprops.reeferData;
        if (reeferData != undefined && reeferData != null && reeferData.length > 0) {
            this.getRefTemperatureUnit();
            var bookingSystem: server.BookingSystem_UIModel = JSON.parse(JSON.stringify(this.state.BookingSystem));
            bookingSystem.reeferID = reeferData[0].ReeferID;
            if (reeferData[0].TemperatureUnit != null) {
                var _lststrValue = reeferData[0].TemperatureUnit.toString().trim().split('@');
                var temperatureCd = _lststrValue[1];
            }
            bookingSystem.BookedTemperatureUnit = temperatureCd != undefined ? temperatureCd : "C";
            bookingSystem.BookingNumber = reeferData[0].BookingNumber;
            bookingSystem.BookedTemperature = reeferData[0].BookedTemperature != null ? reeferData[0].BookedTemperature : '';
            this.setState({ SelectedReefers: reeferData, BookingSystem: bookingSystem });
        }
    }

    BookedTemperatureChange(event: React.FormEvent<HTMLInputElement>) {
        //var bookingSystem: server.BookingSystem_UIModel = JSON.parse(JSON.stringify(this.state.BookingSystem));
        //var Value: number = parseInt(event.currentTarget.value);
        //bookingSystem.BookedTemperature = Value.toString();
        //this.setState({ BookingSystem: bookingSystem });

        var Value: string = event.currentTarget.value.trim();
        var bookingSystem: server.BookingSystem_UIModel = JSON.parse(JSON.stringify(this.state.BookingSystem));
        const IsMatch = /^[-+]?[0-9]*\.?[0-9]*([eE][-+]?[0-9]+)?$/;
        if (IsMatch.test(Value)) {
            bookingSystem.BookedTemperature = Value;
            this.setState({ BookingSystem: bookingSystem });
        }

        else
            return;
    }

    public render() {
        return <div>
            <div>
                <div className='well'>
                    <div className="row" >
                        <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4" >
                            <span className='float-end col-form-label'>Reefer ID:</span>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-7 col-xs-7" >
                            <div className='input-group col-form-label'>
                                {(this.state.BookingSystem != undefined) ? this.state.BookingSystem.reeferID : ''}
                            </div>
                        </div>
                    </div>
                    <div className="row mt-2" >
                        <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4" >
                            <span className='float-end col-form-label'>Booking #:</span>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-7 col-xs-7" >
                            <div className='input-group col-form-label'>
                                {(this.state.BookingSystem != undefined) ? this.state.BookingSystem.BookingNumber : ''}
                            </div>
                        </div>
                    </div>
                    <div className="row mt-2" >
                        <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4" >
                            <span className='float-end col-form-label'>Temperature Unit:</span>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-7 col-xs-7" >
                            <div className='input-group'>
                                <select className='form-control' onChange={e => this.Temperaturechange(e)} value={this.state.BookingSystem.BookedTemperatureUnit}>
                                    <option value="">Temperature Unit</option>
                                    {
                                        this.state.RefTemperatureUnit.map((unit, index) =>
                                            <option key={unit.TemperatureUnitCd + index} value={unit.TemperatureUnitCd}>{unit.TemperatureUnitDesc}</option>
                                        )}
                                </select>
                            </div>
                        </div>
                    </div>
                    <div className="row mt-2" >
                        <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4" >
                            <span className='float-end col-form-label'>Booked Temperature:</span>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-7 col-xs-7" >
                            <div className='input-group'>
                                <input type='text' id='txtBookedTemperature' className='form-control' placeholder='Booked Temperature' onChange={e => this.BookedTemperatureChange(e)} value={this.state.BookingSystem.BookedTemperature} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal-footer">
                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                <button type="button" className="btn btn-primary" onClick={this.submitBookingDetails.bind(this)}>Save</button>
                
            </div>
        </div>
    }
}

class Customers {
    value: string;
    label: string;
    isSelected: boolean;
    disabled: boolean;
    children: CustomerAccessGroups[]
}
class CustomerAccessGroups {
    value: string;
    label: string;
    isSelected: boolean;
    disabled: boolean;
}

